module.exports = __webpack_public_path__ + "static/img/SketchPng4a5bf4722a3b7db29c7d33d05f3bdc62376bf4df5d969d83e736acc28b86ef90.8fdde5b0.png";